import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

export const additionalColors = {
    purple: '#8C00FA',
    trackingRed: '#FF4C06',
    primaryPurple: '#B05DF1',
    secondaryPurple: '#7213BC'
};

// Create a theme instance.
const theme = createTheme(({
    typography: {
        fontSize: 16,
        fontFamily: 'Poppins',
        body1: {
            lineHeight: '1.3',
            fontSize: '1rem',
        },
        body2: {
            fontSize: '0.875rem',
        },
        button: {
            textTransform: 'none',
            color: '#121C27',
            borderRadius: 8,
            fontSize: '1rem',
        },
        h1: {
            fontFamily: 'Domine',
            fontSize: '2em',
        },
        h2: {
            fontFamily: 'Domine',
            fontSize: '1.5em',
        },
        h3: {
            fontFamily: 'Domine',
            fontSize: '1.17em',
        },
        h4: {
            fontFamily: 'Domine',
            fontSize: '1em',
        },
        h5: {
            fontFamily: 'Domine'
        }
    },
    palette: {
        primary: {
            main: '#179af7',
            light: '#54EBD2'
        },
        secondary: {
            main: '#19857b',
        },
        error: {
            main: red.A400,
        },
        warning: {
            main: '#FFC008'
        },
        background: {
            default: '#fff',
        },
        success: {
            main: '#16D79D'
        },
        info: {
            main: '#DCE3EA',
            light: '#EDF1F4',
            dark: '#414952'
        }
    },
    shape: {
        borderRadius: 10
    },
}));

export default theme;